export default __webpack_public_path__ + "static/media/redux.8442924f.png";